var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Copyright"},[_c('div',{staticClass:"container"},[_c('Social'),_c('p',{staticClass:"copyright-text"},[_vm._v("© Copyright 2019 Art Transplant")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }